export const SEARCH_PARAMS = {
  authMessage: 'message',
} as const
